import { createAuth0 } from "@auth0/auth0-vue";

export const auth0Instance = createAuth0({
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,

  cacheLocation: "memory",
  useRefreshTokens: false,

  authorizationParams: {
    redirect_uri: `${window.location.origin}${import.meta.env.VITE_AUTH0_CALLBACK_URL || "/callback"}`,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE_URL,
    oauthTokenScope: "openid profile email",
    scope: "openid profile email VIEW_ALL UPDATE_ALL CREATE_ALL",
  },
});

export const getAccessToken = async (options?: {
  cacheMode?: "on" | "off" | "cache-only";
}): Promise<string> => {
  return await auth0Instance.getAccessTokenSilently(options);
};

export const handleAuthFailure = async (): Promise<void> => {
  await auth0Instance.loginWithRedirect({
    appState: { target: window.location.pathname },
  });
};
